(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('egd-express-checkout')) {
    customElements.define(
      'egd-express-checkout',
      class extends HTMLElement {
        connectedCallback() {
          if (this.form) return;
          this.form = this.closest('form');
          this.payment = this.querySelector('[data-egd-checkout-payment]');
          this.prompt = this.querySelector('[data-egd-checkout-prompt]');
          this.help = this.querySelector('[data-egd-checkout-help]');
          if (!this.form || !this.payment || !this.prompt) return;
          this.onChange = () => this.updateValidity();
          this.onPrompt = () => {
            this.form.reportValidity();
            this.updateValidity();
          };
          this.form.addEventListener('input', this.onChange);
          this.form.addEventListener('change', this.onChange);
          this.prompt.addEventListener('click', this.onPrompt);
          this.updateValidity();
        }

        disconnectedCallback() {
          if (!this.form) return;
          this.form.removeEventListener('input', this.onChange);
          this.form.removeEventListener('change', this.onChange);
          this.prompt.removeEventListener('click', this.onPrompt);
          this.form = null;
        }

        updateValidity() {
          const requiredFields = Array.from(this.form.elements).filter(
            (field) => field.required && field.willValidate
          );
          const valid = requiredFields.every((field) => field.validity.valid);
          this.payment.hidden = !valid;
          this.payment.inert = !valid;
          this.prompt.hidden = valid;
          this.help.hidden = valid;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
